import { useEffect } from 'react';

import { zohoAsapService } from '@services/zohoDeskAsapService';

export function useZohoDeskAsap(enable) {
  useEffect(() => {
    if (enable) zohoAsapService.enable();
    else zohoAsapService.disable();

    return () => zohoAsapService.disable();
  }, [enable]);
}
